import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { Course } from '../../courses/shared/course';
import { CourseLectureService } from '../../courses/shared/course-lecture.service';
import { ConfirmDialogButtonBase } from '../../shared/base/confirm-dialog-button-base';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { MESSAGE_REMOVE_LECTURE_SUCCESS } from '../shared/lecture-message';

@Component({
  selector: 'app-lecture-remove-button',
  template: '<ng-content></ng-content>'
})
export class LectureRemoveButtonComponent extends ConfirmDialogButtonBase {
  @Input() course: Course;
  @Input() lecture: Lecture;

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private refService: CourseLectureService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog('강의 삭제', `${this.lecture.name} 강의를 삭제하시겠습니까?`, '삭제', '취소');
  }

  async onSubmit() {
    try {
      await this.refService.readRef(this.course.$key, this.lecture.$key).remove();
      this.closeDialog();
      this.openSnackBar(MESSAGE_REMOVE_LECTURE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-remove-button/lecture-remove-button.component.ts